import { formatDateToLocale, Formats } from '@toggle/helpers';
import { EarningsItemBase } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useLanguageStore } from '~/stores/use-language-store/useLanguageStore';
import { formatNumberWithUnit } from '~/widgets/earnings/utils/utils';

import * as S from './EarningsInsightSection.styles';

export interface PreviewContentProps {
  earningsData: EarningsItemBase;
}

export const PreviewContent = ({ earningsData }: PreviewContentProps) => {
  const { t } = useTranslation(['widget']);
  const languageSetting = useLanguageStore(state => state.languageSetting);

  const formattedDate = earningsData.reporting_date
    ? formatDateToLocale(
        languageSetting,
        new Date(earningsData.reporting_date),
        Formats['MMMM d']
      )
    : '-';

  const reportPeriod =
    earningsData.fiscal_period && earningsData.fiscal_year
      ? `${earningsData.fiscal_period} ${earningsData.fiscal_year}`
      : '-';

  return (
    <>
      <S.MetricContainer>
        <S.MetricLabel>
          {t('widget:assetOverview.earningsSection.nextReportDate')}
        </S.MetricLabel>
        <S.MetricValue>{formattedDate}</S.MetricValue>
      </S.MetricContainer>
      <S.MetricContainer>
        <S.MetricLabel>
          {t('widget:assetOverview.earningsSection.reportPeriod')}
        </S.MetricLabel>
        <S.MetricValueMono>{reportPeriod}</S.MetricValueMono>
      </S.MetricContainer>
      <S.MetricContainer>
        <S.MetricLabel>
          {t('widget:assetOverview.earningsSection.epsEstimate')}
        </S.MetricLabel>
        <S.MetricValueMono>
          {formatNumberWithUnit(earningsData.eps?.estimate)}
          <S.CurrencyLabel>{earningsData.currency ?? 'USD'}</S.CurrencyLabel>
        </S.MetricValueMono>
      </S.MetricContainer>
      <S.MetricContainer>
        <S.MetricLabel>
          {t('widget:assetOverview.earningsSection.revenueEstimate')}
        </S.MetricLabel>
        <S.MetricValueMono>
          {formatNumberWithUnit(earningsData.revenue?.estimate)}
          <S.CurrencyLabel>{earningsData.currency ?? 'USD'}</S.CurrencyLabel>
        </S.MetricValueMono>
      </S.MetricContainer>
    </>
  );
};
